
export function BPMRedirect(props: { to: string }) {
    location.replace(props.to)
    return null;
}


// WEBPACK FOOTER //
// ./src/components/BPMRedirect.tsx